import { render, staticRenderFns } from "./TopNew.vue?vue&type=template&id=f81d3db6"
import script from "./TopNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/top/TopNew.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports